<!--单选 SCQ-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">备注</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56"> 备注说明 </span>
      </p>
    </div>
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>
    <div class="select-view">
      <!-- <p style="font-size: 28rpx; color: #2b2f36; word-break: break-all">
        {{ dataObj.caseProblem }}
      </p> -->
      <div class="rich-text-content" v-html="dataObj.caseProblem"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      list: [],
      images: [],
    };
  },
  methods: {},
  watch: {
    params: {
      handler(newVal, oldVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.select-view {
  width: 100%;
  height: 120px;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 12px;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  border: 1px solid #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewRemark.vue